import React from 'react';

import Typography from '@material-ui/core/Typography';

var variant = {
    'h1': 'h4',
    'h2': 'h5',
    'h3': 'h6',
    'h4': 'subtitle1'
};

export default function H1(props) {
    var label = props.label,
        options = props.options;
    var titleType = options.titleType;


    return React.createElement(
        Typography,
        {
            variant: variant[titleType],
            component: titleType
        },
        label
    );
};